import { render, staticRenderFns } from "./SliderGroup.vue?vue&type=template&id=9d60ce20&scoped=true&"
import script from "./SliderGroup.vue?vue&type=script&lang=js&"
export * from "./SliderGroup.vue?vue&type=script&lang=js&"
import style0 from "./SliderGroup.vue?vue&type=style&index=0&id=9d60ce20&scoped=true&lang=css&"
import style1 from "./SliderGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d60ce20",
  null
  
)

export default component.exports